<div class="question">
  <p>{{ question }}</p>
  <label *ngFor="let choice of choices; let i = index" class="custom-checkbox">
    <input type="checkbox"
           [checked]="ratingService.selectedChoiceIndex === i"
           (change)="toggleChoice(i)">
    <span class="checkbox-indicator"></span>
    {{ choice }}
  </label>
</div>
